import { authenticatedPatientSelector, currentPatientSelector } from '../selectors/patients-selectors.ts';

module.exports = class PatientAppContextService {

  static $inject = [
    '$ngRedux',
    '$state',
  ];

  constructor(
    $ngRedux,
    $state,
  ) {
    this.$ngRedux = $ngRedux;
    this.$state = $state;

    this.walkinCode = 'WALK_IN';

    this.initializeStateConnection();
  }

  initializeStateConnection() {
    this.context = { group: null, patient: null, reason: null, authenticatedPatient: null, notifications: null };

    // Workaround until all components use directly Redux state to get context
    this.$ngRedux.connect(state => ({
      authenticatedPatient: authenticatedPatientSelector(state),
      group: state.group,
      notifications: state.notifications,
      patient: currentPatientSelector(state),
      reason: state.reasons.current,
    }))(this.context);
  }

  // TODO: Should be removed from this service
  goToFirstStep() {
    return this.$state.go('patients.id.home', { patientId: this.context.patient.id });
  }
};



// WEBPACK FOOTER //
// ./main/services/patient-app-context-service.js